import { Redirect, RouteComponentProps, Router } from '@reach/router';
import React, { ComponentType } from 'react';
import { SubNav } from '../sub-nav.component';
import { Editor } from './editor/editor.component';
import { List } from './list/list.component';

type EnterpriseDetailParams = {
  id?: string;
};

interface Props {
  enterprise: { id: string; name: string };
}

export const PropertySchema: ComponentType<
  RouteComponentProps<EnterpriseDetailParams> & Props
> = (props) => {
  const { enterprise } = props;
  return (
    <>
      <SubNav current="property-schemas" />
      <Router className="router">
        <Editor path="create" />
        <Editor path=":propertySchemaId/edit" />
        <List path="list" enterprise={enterprise} />
        <Redirect from="/" to="list" />
      </Router>
    </>
  );
};
